import * as React from 'react'
import { TelemetryType } from '../../api/apiservice'

import BaseSensor from './BaseSensor'
export default class TubingPressures extends BaseSensor {
  constructor(props) {
    super(props, TelemetryType.TubingPressure, 'Tubing Pressure')
  }

  protected formatValue = (value?: any, timeStamp?: Date): React.ReactNode => {
    if (typeof value !== 'number') {
      return 'N/A'
    }
    return <React.Fragment>{value}</React.Fragment>
  }

  protected getDisplayReading(readingValue?: number): number | undefined {
    return readingValue
  }
}
